import React from "react";

import { useDebouncedCallback } from "use-debounce";

import { useUmpiresContext } from "../../../contexts/Umpires";

import { updateUmpire } from "../../../../../../lib/api";
import { IUmpireUser, TUserStatus } from "../../../../../../types/api";
import { AsyncStatuses } from "../../../../../../types/shared";

export const useUmpireInfoHandlers = (
    setUpdateStatus: React.Dispatch<React.SetStateAction<AsyncStatuses>>,
) => {
    const { setUmpires } = useUmpiresContext();

    const handleStatusChange = async (
        umpireId: IUmpireUser["id"],
        status: TUserStatus,
    ) => {
        setUpdateStatus("pending");
        updateUmpire(umpireId, { status })
            .then(response => {
                setUpdateStatus("success");
                setUmpires(prev => {
                    const newUmpires = prev.map(u => {
                        return u.id === response.umpire.id
                            ? {
                                  ...u,
                                  status: response.umpire.status,
                              }
                            : u;
                    });
                    return newUmpires;
                });
                setTimeout(() => {
                    setUpdateStatus(undefined);
                }, 3000);
            })
            .catch(e => {
                setUpdateStatus("failed");
            });
    };

    const handleCommentsChange = async (
        umpireId: IUmpireUser["id"],
        comments: IUmpireUser["comments"],
    ) => {
        console.log(comments);
        setUpdateStatus("pending");
        updateUmpire(umpireId, { comments })
            .then(response => {
                setUpdateStatus("success");
                setUmpires(prev => {
                    const newUmpires = prev.map(u => {
                        return u.id === response.umpire.id
                            ? {
                                  ...u,
                                  comments: response.umpire.comments,
                              }
                            : u;
                    });
                    return newUmpires;
                });
                setTimeout(() => {
                    setUpdateStatus(undefined);
                }, 3000);
            })
            .catch(e => {
                setUpdateStatus("failed");
            });
    };

    const debouncedHandleCommentsChange = useDebouncedCallback(
        ({
            umpire,
            comments,
        }: {
            umpire: IUmpireUser;
            comments: IUmpireUser["comments"];
        }) => {
            handleCommentsChange(umpire.id, comments);
        },
        1000,
    );

    return {
        handleCommentsChange: debouncedHandleCommentsChange,
        handleStatusChange,
    };
};
